export type BannerTextStyle = {
  fontFamily?: 'geologica' | 'chiron' | null;
  fontSize?: string | null;
  fontSizeDesktop?: string | null;
};

const getHeadingClass = (token: string, prefix = 'heading') => {
  if (token.startsWith('italic-')) {
    return `${prefix}-italic-${token.slice('italic-'.length)}`;
  }

  return `${prefix}-${token}`;
};

export function getBannerTextClassName(style?: BannerTextStyle | null): string {
  if (!style?.fontFamily && !style?.fontSize && !style?.fontSizeDesktop) {
    return '';
  }

  const classes: string[] = [];

  if (style.fontFamily === 'chiron') {
    classes.push('font-additional', 'italic');
  } else if (style.fontFamily === 'geologica') {
    classes.push('font-base', 'not-italic');
  }

  if (style.fontSize) {
    classes.push(getHeadingClass(style.fontSize));
  }

  if (style.fontSizeDesktop) {
    classes.push(getHeadingClass(style.fontSizeDesktop, 'md:heading'));
  }

  return classes.join(' ');
}

export function getBannerTextClassNameWithFallback(
  fallbackStyle: BannerTextStyle,
  style?: BannerTextStyle | null
): string {
  return getBannerTextClassName({
    fontFamily: style?.fontFamily ?? fallbackStyle.fontFamily,
    fontSize: style?.fontSize ?? fallbackStyle.fontSize,
    fontSizeDesktop: style?.fontSizeDesktop ?? fallbackStyle.fontSizeDesktop
  });
}
